import {
  ErrorHandler,
  EnvironmentProviders,
  inject,
  Injectable,
  makeEnvironmentProviders,
  Provider,
  provideAppInitializer,
} from '@angular/core';

import {
  APP_LOGGER_CONFIG,
  AppLoggerService,
  type AppLoggerConfig,
  type AppLoggerConfigSource,
} from '../services/app-logger.service';

@Injectable()
class AppLoggerErrorHandler implements ErrorHandler {
  private readonly logger = inject(AppLoggerService);

  handleError(error: unknown): void {
    if (this.logger.isGlobalErrorCaptureEnabled()) {
      this.logger.captureException(error);
    }
    console.error(error);
  }
}

export function provideAppLogger(config: AppLoggerConfigSource = {}): EnvironmentProviders {
  const staticConfig = typeof config === 'function' ? {} : config;
  const providers: Array<Provider | EnvironmentProviders> = [
    { provide: APP_LOGGER_CONFIG, useValue: staticConfig },
    provideAppInitializer(async () => {
      const logger = inject(AppLoggerService);
      const resolvedConfig = await resolveAppLoggerConfig(config);

      logger.init(resolvedConfig);

      // app_opened au démarrage (si startupLog.enabled) — fire-and-forget, ne bloque pas le bootstrap
      void logger.emitStartupLog();
    }),
  ];

  if (typeof config === 'function' || config.captureGlobalErrors) {
    providers.push({ provide: ErrorHandler, useClass: AppLoggerErrorHandler });
  }

  return makeEnvironmentProviders(providers);
}

async function resolveAppLoggerConfig(config: AppLoggerConfigSource): Promise<AppLoggerConfig> {
  return typeof config === 'function' ? await config() : config;
}
